import React from 'react';
import { StandardButton, type IStandardButton } from '@soulhx/ui-common';

type IStyledButton = IStandardButton & { rpVariant: string };
export const StyledButton = ({ rpVariant, ...props }: IStyledButton) => {
  return (
    <StandardButton
      variant={
        rpVariant === 'rpi-completed'
          ? 'outline-success'
          : rpVariant === 'rpi-yellow'
          ? 'outline-dark'
          : rpVariant === 'rpi-red'
          ? 'outline-danger'
          : undefined
      }
      {...props}
    />
  );
};
